import script from "./maintenance-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./maintenance-banner.vue?vue&type=script&setup=true&lang=js"

import "./maintenance-banner.vue?vue&type=style&index=0&id=40dd32b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40dd32b3"]])

export default __exports__